module.exports = __webpack_public_path__ + "img/logo-sialar-2.db4de879.jpg";